__turbopack_context__.v({
  "RowAznobaharSmallMobile": "Mg-FoW_RowAznobaharSmallMobile",
  "aznobahar": "Mg-FoW_aznobahar",
  "aznobaharSmallMobile": "Mg-FoW_aznobaharSmallMobile",
  "borderTop": "Mg-FoW_borderTop",
  "borderTopNone": "Mg-FoW_borderTopNone",
  "container": "Mg-FoW_container",
  "desktopMainLink": "Mg-FoW_desktopMainLink",
  "desktopSubMenuBtn": "Mg-FoW_desktopSubMenuBtn",
  "enLangButtonStyles": "Mg-FoW_enLangButtonStyles",
  "hamMenuWrapper": "Mg-FoW_hamMenuWrapper",
  "justifyStartSmallCenter": "Mg-FoW_justifyStartSmallCenter",
  "logoContainer": "Mg-FoW_logoContainer",
  "logoContainerTitle": "Mg-FoW_logoContainerTitle",
  "logoContainerVerticalLine": "Mg-FoW_logoContainerVerticalLine",
  "mainMenuBtn": "Mg-FoW_mainMenuBtn",
  "menuContainer": "Mg-FoW_menuContainer",
  "mobileMainMenuBtn": "Mg-FoW_mobileMainMenuBtn",
  "mobileSubMenuBtn": "Mg-FoW_mobileSubMenuBtn",
  "mobileSubMenuBtnTitle": "Mg-FoW_mobileSubMenuBtnTitle",
  "mobileSubMenuContainer": "Mg-FoW_mobileSubMenuContainer",
  "rightArrowTitlSubStyles": "Mg-FoW_rightArrowTitlSubStyles",
  "searchBtn": "Mg-FoW_searchBtn",
  "secondContainerBg": "Mg-FoW_secondContainerBg",
  "secondLogoContainerVerticalLine": "Mg-FoW_secondLogoContainerVerticalLine",
  "subMenuContainer": "Mg-FoW_subMenuContainer",
});
